import moment from 'moment';
import { utils } from '@sfaas/util';
class MappingModel {
	constructor(mapping) {
		Object.assign(this, mapping);
		const { procExeStat, procStat, procControl, heartDt } = mapping;
		this.procExeStat = procExeStat === 'Y' ? 'START' : 'STOP';
		this.procStat = this.procStatConverter(procStat);
		this.procControl = this.procControlConverter(procControl);
		this.heartDt = !utils.$sf_isNull(heartDt) && !utils.isUndefined(heartDt) ? moment(heartDt).format('YYYY-MM-DD HH:mm:ss') : heartDt;
	}

	procStatConverter(procStat) {
		switch (procStat) {
			case '1':
				return 'START';
			case '0':
				return 'STOP';
			default:
				return procStat;
		}
	}

	procControlConverter(procControl) {
		switch (procControl) {
			case '1':
				return 'START';
			case '0':
				return 'STOP';
			default:
				return 'HOLDING';
		}
	}
}

export default MappingModel;
